var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 678.9 680.7",
    style: {
      enableBackground: "new 0 0 678.9 680.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.6,390.7c1.4-10.5-1.2-20-7.7-28.4c-6.5-8.4-15-13.3-25.5-14.7c-10.5-1.4-20,1.2-28.5,7.7L15,483.5 c-6.4,5-10.8,11.3-13.2,19c-2.4,7.7-2.4,15.3,0,23c2.4,7.7,6.8,14,13.2,19l165.8,128.2c8.5,6.5,18,9,28.5,7.7 c10.5-1.4,19-6.3,25.5-14.7c6.5-8.4,9.1-17.9,7.7-28.4c-1.4-10.5-6.2-19-14.6-25.5l-76.7-59.2h489c10.6,0,19.7-3.8,27.2-11.2 c7.5-7.5,11.3-16.6,11.3-27.2c0-10.6-3.8-19.7-11.3-27.2c-7.5-7.5-16.6-11.3-27.2-11.3H151.3l76.7-59.2 C236.3,409.7,241.2,401.2,242.6,390.7 M677.1,178.3c2.4-7.7,2.4-15.4,0-23.1c-2.4-7.7-6.8-14-13.2-18.9L498,8.1 c-8.5-6.5-17.9-9.1-28.4-7.7C459,1.7,450.5,6.6,444,15.1c-6.5,8.4-9.1,17.9-7.7,28.4c1.4,10.5,6.2,19,14.6,25.5l76.7,59.2H38.5 c-10.6,0-19.7,3.8-27.2,11.3C3.8,147,0,156.1,0,166.7c0,10.6,3.8,19.7,11.3,27.2c7.5,7.5,16.6,11.2,27.2,11.2h489.1l-76.6,59.3 c-8.4,6.5-13.2,15-14.6,25.6c-1.4,10.5,1.2,20,7.7,28.4c6.5,8.4,15,13.3,25.6,14.7c10.5,1.4,20-1.2,28.4-7.7l165.8-128.2 C670.2,192.2,674.6,185.9,677.1,178.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplaceIcon);
export default __webpack_public_path__ + "static/media/replace_icon.a7061452.svg";
export { ForwardRef as ReactComponent };